<template>
  <b-modal
    ref="configurationPersonnelForm"
    size="xxl"
    centered
    modal-class="configuration-modal-tabs configuration-personnel-form"
    static
    hide-footer
    @hide="onHide()"
  >
    <div
      slot="modal-title"
      class="d-flex align-items-center"
    >
      {{ actionTitle }} {{ $t('configuration.sections.personnel').toLowerCase() }}
    </div>
    <b-row class="px-0">
      <b-col class="px-2 pt-1 pb-2">
        <div>
          <b-tabs
            v-model="activeTabIndex"
            pills
            card
            vertical
            class="vt-tabs--pills"
          >
            <b-tab active>
              <template slot="title">
                <i
                  class="far fa-list-ul mr-2"
                  aria-hidden="true"
                />
                {{ $t('configuration.modal.basicData') }}
              </template>
              <b-row
                style=""
                class="scroll-area px-1 pt-1 pb-3"
              >
                <b-col class="mt-3">
                  <b-row>
                    <b-col>
                      <div class="form-card">
                        <span class="ap-title ap-title__section"><i
                          class="far fa-user mr-2 mb-2"
                          aria-hidden="true"
                        />{{ $t('configuration.modal.personnel.personnelData') }}</span>
                        <b-row class="mt-2">
                          <b-col
                            cols="4"
                            class="mb-3"
                          >
                            <div class="form-label">
                              <label>{{ $t('configuration.grid.externalCode') }} *</label>
                            </div>
                            <vt-input
                              v-model="internalPersonnel.code"
                              class="form-control-sm"
                            />
                          </b-col>
                          <b-col
                            cols="4"
                            class="mb-3"
                          >
                            <div class="form-label">
                              <label>{{ $t('configuration.grid.name') }} *</label>
                            </div>
                            <vt-input
                              v-model="internalPersonnel.name"
                              class="form-control-sm"
                            />
                          </b-col>
                          <b-col
                            v-if="globalParameters.middleNameSupported"
                            cols="4"
                            class="mb-3"
                          >
                            <div class="form-label">
                              <label>{{ $t('configuration.grid.middleName') }}</label>
                            </div>
                            <vt-input
                              v-model="internalPersonnel.middleName"
                              class="form-control-sm"
                            />
                          </b-col>
                          <b-col
                            cols="4"
                            class="mb-3"
                          >
                            <div class="form-label">
                              <label>{{ $t('configuration.grid.surname1') }} *</label>
                            </div>
                            <vt-input
                              v-model="internalPersonnel.surname1"
                              class="form-control-sm"
                            />
                          </b-col>
                          <b-col
                            cols="4"
                            class="mb-3"
                          >
                            <div class="form-label">
                              <label>{{ $t('configuration.grid.surname2') }}</label>
                            </div>
                            <vt-input
                              v-model="internalPersonnel.surname2"
                              class="form-control-sm"
                            />
                          </b-col>
                          <b-col
                            cols="4"
                            class="mb-3"
                          >
                            <div class="form-label">
                              <label>{{ $t('configuration.grid.job') }} *</label>
                            </div>
                            <vt-combo-select
                              v-model="internalPersonnel.job"
                              v-validate="'required'"
                              track-by="id"
                              :options="jobsList"
                              label="translatedName"
                            />
                          </b-col>
                          <b-col
                            cols="4"
                            class="mb-3"
                          >
                            <div class="form-label">
                              <label>{{ $t('configuration.grid.laboratory') }} *</label>
                            </div>
                            <vt-combo-select
                              v-model="internalPersonnel.defaultLaboratory"
                              v-validate="'required'"
                              track-by="labId"
                              :options="laboratories.filter(lab => !lab.all)"
                              label="labName"
                            />
                          </b-col>
                          <b-col
                            cols="4"
                            class="mb-3"
                          >
                            <div class="form-label">
                              <label>{{ $t('configuration.grid.annualUCL') }}</label>
                            </div>
                            <vt-input
                              v-model="internalPersonnel.expectedAnnualUCLValue"
                              type="number"
                              :step="0.01"
                              class="form-control-sm"
                            />
                          </b-col>
                        </b-row>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3 mb-2">
                    <b-col>
                      <div class="form-card">
                        <span class="ap-title ap-title__section"><i
                          class="far fa-envelope mr-2 mb-2"
                          aria-hidden="true"
                        />{{ $t('configuration.modal.contactAndNotifications') }}</span>
                        <b-row class="mt-2">
                          <b-col
                            cols="6"
                            class="mb-3"
                          >
                            <div class="form-label">
                              <label>{{ $t('configuration.grid.email') }}</label>
                            </div>
                            <vt-input
                              v-model="internalPersonnel.contactInformation.email"
                              class="form-control-sm"
                            />
                          </b-col>
                          <b-col
                            cols="6"
                            class="mb-3 d-flex align-items-center justify-content-end"
                          >
                            <div class="switch-btn mt-1 p-0 d-flex align-items-center">
                              <span class="mr-2">{{ $t('configuration.modal.emailNotifications') }}</span>
                              <input
                                id="toggle-email"
                                v-model="internalPersonnel.contactInformation.emailNotificationEnabled"
                                :disabled="!personnelEmail"
                                type="checkbox"
                                class="offscreen"
                                aria-hidden="true"
                              >
                              <label
                                :class="{ 'disabled' : !personnelEmail }"
                                for="toggle-email"
                                class="switch mb-0"
                              />
                            </div>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col
                            cols="6"
                            class="mb-3"
                          >
                            <div class="form-label">
                              <label>{{ $t('configuration.grid.phone') }}</label>
                            </div>
                            <vt-input
                              v-model="internalPersonnel.contactInformation.mainPhone"
                              class="form-control-sm"
                            />
                          </b-col>
                          <b-col
                            cols="6"
                            class="mb-3 d-flex align-items-center justify-content-end"
                          >
                            <div class="switch-btn mt-1 p-0 d-flex align-items-center">
                              <span class="mr-2">{{ $t('configuration.modal.smsNotifications') }}</span>
                              <input
                                id="toggle-sms"
                                v-model="internalPersonnel.contactInformation.smsNotificationEnabled"
                                :disabled="!personnelMainPhone"
                                type="checkbox"
                                class="offscreen"
                                aria-hidden="true"
                              >
                              <label
                                for="toggle-sms"
                                :class="{ 'disabled' : !personnelMainPhone }"
                                class="switch mb-0"
                              />
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col
                      cols="12"
                      class="my-2 d-flex justify-content-end"
                    >
                      <div class="switch-btn mt-1 p-0 d-flex align-items-center">
                        <span class="mr-2">{{ $t('configuration.grid.globalValidation') }}</span>
                        <input
                          id="globalValidationToggle"
                          v-model="internalPersonnel.allowsCaseValidationByOtherUsers"
                          type="checkbox"
                          class="offscreen"
                          aria-hidden="true"
                        >
                        <label
                          for="globalValidationToggle"
                          class="switch mb-0"
                        />
                      </div>
                    </b-col>
                    <b-col
                      cols="12"
                      class="my-2 d-flex justify-content-end"
                    >
                      <div class="switch-btn mt-1 p-0 d-flex align-items-center">
                        <span
                          v-if="internalPersonnel.active"
                          class="mr-2"
                        >{{ $t('configuration.actions.active') }}</span>
                        <span
                          v-else
                          class="mr-2"
                        >{{ $t('configuration.actions.inactive') }}</span>
                        <input
                          id="toggle"
                          v-model="internalPersonnel.active"
                          type="checkbox"
                          class="offscreen"
                          aria-hidden="true"
                        >
                        <label
                          for="toggle"
                          class="switch mb-0"
                        />
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <div class="footer-area component-bg d-flex justify-content-between px-3 py-2 align-items-center">
                <div>
                  <b-button
                    :disabled="!internalPersonnel.id"
                    :to="{ name: 'PeopleUserapp', params: { actions: getActions(internalPersonnel) } }"
                    class="btn__link"
                  >
                    <span>{{ $t('configuration.modal.goToUser') }}</span>
                  </b-button>
                </div>
                <div>
                  <b-button
                    :disabled="!internalPersonnel.code || !internalPersonnel.name || !internalPersonnel.surname1 || isEmpty(internalPersonnel.defaultLaboratory) || isEmpty(internalPersonnel.job)"
                    size="sm"
                    class="btn--primary"
                    @click="update"
                  >
                    <i
                      class="fal fa-check mr-2"
                      aria-hidden="true"
                    />
                    {{ actionTitle }}
                  </b-button>
                </div>
              </div>
            </b-tab>
            <b-tab :disabled="!internalPersonnel.id">
              <template slot="title">
                <i
                  class="far fa-project-diagram mr-2"
                  aria-hidden="true"
                />
                {{ $tc('configuration.modal.responsibility', 2) }}
              </template>
              <b-row
                style="height: 100%"
                class="p-3"
              >
                <b-col cols="12">
                  <span class="title">{{ $tc('configuration.modal.responsibility', 2) }}</span>
                </b-col>
                <b-col class="mt-2 tab-scroll-content without-footer association-table pl-0 pr-2 mx-2">
                  <div class="d-flex mb-1 header-row">
                    <div class="d-flex">
                      <div class="fixed-column">
                        <vt-input
                          v-model="filter"
                          class="form-control-sm"
                          :placeholder="$t('configuration.modal.filterResponsibilities')"
                        />
                      </div>
                      <div
                        v-for="(laboratory, index) in laboratories"
                        :key="index"
                        class="check-column d-flex align-items-center"
                      >
                        <span
                          v-tooltip="laboratory.labName"
                          class="pl-2"
                        >{{ laboratory.labName }}</span>
                      </div>
                    </div>
                  </div>
                  <div
                    v-for="(association, index) in filteredInternalResponsibilities"
                    :key="index"
                    class="d-flex"
                  >
                    <div class="d-flex bottom-line">
                      <div class="fixed-column">
                        <span>{{ association.responsibility.translatedName }}</span>
                      </div>
                      <div
                        v-for="(lab, indexLab) in association.laboratories"
                        :key="indexLab"
                        class="check-column d-flex align-items-center"
                        :class="indexLab"
                      >
                        <b-form-checkbox
                          v-model="lab.assigned"
                          class="ml-2"
                          @change="personnelResponsibilityChanged(lab, association)"
                        />
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import ResponsibilityConfigurationServices from '@/api/resources/configuration/peopleManagement/responsibility/ResponsibilityConfigurationServices'
import PersonnelResponsibilityConfigurationServices from '@/api/resources/configuration/peopleManagement/personnel/PersonnelResponsibilityConfigurationServices'
import JobConfigurationServices from '@/api/resources/configuration/peopleManagement/job/JobConfigurationServices'
import { cloneDeep, isEmpty } from 'lodash'
import { ASSOCIATION_TYPE } from '@/api/resources/configuration/peopleManagement/AssociationTypes'
import { StoreUtils } from '@/shared/util/store-utils'

const DATA_TAB = 0
const RESPONSIBILITIES_TAB = 1

export default {
    name: 'ConfigurationPersonnelForm',
    props: {
        actionTitle: String
    },
    data() {
        return {
            filter: '',
            activeTabIndex: DATA_TAB,
            internalOriginalResponsibilities: [],
            internalResponsibilities: [],
            internalPersonnel: {},
            originalPersonnel: {},
            jobsList: []
        }
    },
    computed: {
        filteredInternalResponsibilities() {
            return this.internalOriginalResponsibilities.filter(association => {
                return association.responsibility.translatedName.toLowerCase().includes(this.filter.toLowerCase())
            })
        },
        laboratories() {
            // TODO Debería filtrarse por los permisos del usuario para crear/eliminar PersonnelResponsibilities en cada laboratorio
            const laboratoriesConfiguration = [...StoreUtils.laboratories]
            laboratoriesConfiguration.unshift({ labName: this.$tc('global.all'), all: true })
            return laboratoriesConfiguration
        },
        personnelMainPhone() {
            return this.internalPersonnel.contactInformation.mainPhone
        },
        personnelEmail() {
            return this.internalPersonnel.contactInformation.email
        },
        ASSOCIATION_TYPE() {
            return ASSOCIATION_TYPE
        }
    },
    async created() {
        this.updateLoading(true)
        const [err, data] = await this.toCall(JobConfigurationServices.getJobs())
        this.updateLoading(false)
        if (err) {
            this.showErrorModalGlobal()
            return
        }
        this.jobsList = data
    },
    beforeMount() {
        this.initPersonnel()
    },
    methods: {
        getActions(entity) {
            let actionObj = {}
            if (entity.user) {
                actionObj = { updateUser: { userId: entity.user.id } }
            } else {
                actionObj = { createUser: { personnelId: entity.id } }
            }
            return actionObj
        },
        async show(selectedPersonnel, associationType) {
            let targetTab = DATA_TAB
            this.filter = ''
            if (selectedPersonnel && !isEmpty(selectedPersonnel)) {
                await this.setPersonnelResponsibilities(selectedPersonnel)
            } else {
                this.clearInternalData()
            }
            if (associationType) {
                if (associationType === this.ASSOCIATION_TYPE.RESPONSIBILITY.key) {
                    targetTab = RESPONSIBILITIES_TAB
                }
            }
            this.activeTabIndex = targetTab
            this.$refs.configurationPersonnelForm.show()
        },
        async createPersonnelResponsibility(lab, association) {
            const personnelResponsibilityCreateRequest = {
                jobCode: this.internalPersonnel.job.code,
                personnelId: this.internalPersonnel.id,
                laboratoryId: lab.labId,
                responsibilityCode: association.responsibility.code
            }
            const [err, response] = await this.toCall(PersonnelResponsibilityConfigurationServices.createPersonnelResponsibility(personnelResponsibilityCreateRequest))
            if (err) {
                lab.assigned = false
                this.showErrorModalGlobal(err.message)
                return err
            }
            lab.assigned = true
            lab.personnelResponsibilityId = response.id
        },
        async deletePersonnelResponsibility(lab) {
            const [err] = await this.toCall(PersonnelResponsibilityConfigurationServices.deletePersonnelResponsibility(lab.personnelResponsibilityId))
            if (err) {
                lab.assigned = true
                this.showErrorModalGlobal(err.message)
                return err
            }
            lab.assigned = false
        },
        clearInternalData() {
            this.clearPersonnelResponsibilityData()
            this.clearPersonnelData()
        },
        clearPersonnelResponsibilityData() {
            this.internalResponsibilities = []
            this.internalOriginalResponsibilities = []
        },
        async personnelResponsibilityChanged(lab, association) {
            let err = null
            let allResponsibilityLabs = []
            if (lab.all) {
                [err, allResponsibilityLabs] = this.allLabsPersonnelResponsibilityChanged(lab, association)
            } else {
                if (lab.assigned) {
                    err = await this.createPersonnelResponsibility(lab, association)
                } else err = await this.deletePersonnelResponsibility(lab, association)
            }
            if (!err) {
                if (lab.all) {
                    if (lab.assigned) {
                        this.showToastSuccessGlobal(this.$tc('configuration.toastMessages.personnelResponsibilityCreated', allResponsibilityLabs.length, { personnelResponsibilities: allResponsibilityLabs.length }))
                    } else {
                        this.showToastSuccessGlobal(this.$tc('configuration.toastMessages.personnelResponsibilityDeleted', allResponsibilityLabs.length, { personnelResponsibilities: allResponsibilityLabs.length }))
                    }
                } else {
                    if (lab.assigned) {
                        this.showToastSuccessGlobal(this.$tc('configuration.toastMessages.personnelResponsibilityCreated', 1))
                    } else {
                        this.showToastSuccessGlobal(this.$tc('configuration.toastMessages.personnelResponsibilityDeleted', 1))
                    }
                }
            }
        },
        allLabsPersonnelResponsibilityChanged(allLabs, association) {
            this.updateLoading(true)
            const allResponsibilityLabs = association.laboratories.filter(lab => !lab.all && allLabs.assigned !== lab.assigned)
            let err = null
            allResponsibilityLabs.forEach(async lab => {
                if (!lab.assigned) {
                    err = await this.createPersonnelResponsibility(lab, association)
                } else {
                    err = await this.deletePersonnelResponsibility(lab, association)
                }
            })
            this.updateLoading(false)
            return [err, allResponsibilityLabs]
        },
        async setPersonnelResponsibilities(personnel) {
            this.internalPersonnel = cloneDeep(personnel)
            this.originalPersonnel = cloneDeep(personnel)
            this.updateLoading(true)
            const [err, response] = await this.toCall(Promise.all([
                ResponsibilityConfigurationServices.getResponsibilities(),
                PersonnelResponsibilityConfigurationServices.getPersonnelResponsibilitiesByPersonnelId(personnel.id)]))
            this.updateLoading(false)
            if (err) {
                this.$refs.configurationPersonnelForm.hide()
                this.showErrorModalGlobal()
                return
            }
            const responsibilities = response[0]
            const personnelResponsibilities = response[1]
            responsibilities.forEach(responsibility => {
                let responsibilityParsed = {
                    responsibility: responsibility,
                    laboratories: this.laboratories.map(lab => {
                        let parsedLab = {}
                        parsedLab.labId = lab.labId
                        parsedLab.assigned = false
                        if (lab.all) parsedLab.all = lab.all
                        return parsedLab
                    })
                }
                this.setResponsibilityLaboratories(responsibilityParsed, personnelResponsibilities)
                this.internalResponsibilities.push(responsibilityParsed)
            })
            this.internalOriginalResponsibilities = cloneDeep(this.internalResponsibilities)
        },
        setResponsibilityLaboratories(responsibilityParsed, personnelResponsibilities) {
            responsibilityParsed.laboratories.forEach(lab => {
                personnelResponsibilities.forEach(personnelResponsibility => {
                    if (personnelResponsibility.responsibility.id === responsibilityParsed.responsibility.id && lab.labId === personnelResponsibility.laboratory.labId) {
                        lab.personnelResponsibilityId = personnelResponsibility.id
                        lab.assigned = true
                    }
                })
            })
            const labsAssigned = responsibilityParsed.laboratories.filter(lab => lab.assigned).length
            let allLabs = responsibilityParsed.laboratories.find(lab => lab.all)
            if (labsAssigned === this.laboratories.length - 1) {
                allLabs.assigned = true
            }
        },
        update() {
            if (this.internalPersonnel.id) {
                let updateRequest = {
                    ...this.internalPersonnel
                }
                if (this.originalPersonnel.job?.code !== this.internalPersonnel.job?.code) {
                    updateRequest.jobCode = this.internalPersonnel.job.code
                } else {
                    delete updateRequest.jobCode
                }
                this.$emit('update', updateRequest)
            } else {
                this.$emit('create', this.internalPersonnel)
            }
        },
        initPersonnel() {
            this.internalPersonnel = {
                active: true,
                allowsCaseValidationByOtherUsers: false,
                code: '',
                contactInformation: {},
                defaultLaboratory: {},
                job: {},
                fullName: '',
                middleName: null,
                surname1: '',
                surname2: '',
                name: '',
                user: null
            }
        },
        clearPersonnelData() {
            this.initPersonnel()
        },
        isEmpty(value) {
            return isEmpty(value)
        },
        onHide() {
            this.clearInternalData()
        },
        hide() {
            this.clearInternalData()
            this.$refs.configurationPersonnelForm.hide()
        }
    }
}
</script>

<style lang="scss">
    .configuration-personnel-form .modal-body {
        border-radius: .3rem;
    }
    .configuration-personnel-form .tab-content {
        height: calc(100vh - 300px);
        overflow-y: auto;
    }
    @media only screen and (max-width: 1366px) and (min-width: 1360px) {
        .configuration-personnel-form .tab-content {
            height: calc(100vh - 160px);
        }
    }
</style>
